import { LanguagesEnum } from 'common/enums/languages'

export const normalizeLanguage = (
  lang: string | null,
  defaultLanguage: LanguagesEnum = LanguagesEnum.EN_US,
): LanguagesEnum => {
  if (!lang) return defaultLanguage

  if (lang.includes('pt')) return LanguagesEnum.PT_BR
  if (lang.includes('en')) return LanguagesEnum.EN_US
  if (lang.includes('es')) return LanguagesEnum.ES_ES

  return defaultLanguage
}
